<template>
  <div class="devices-widget">
    <h2><span class="fa fa-weight" /> Devices</h2>
    <div v-if="config.endpoint">
      <h3>Last Data Received</h3>
      <div v-if="loading">
        Loading Devices <span class="fa fa-sync anim-spin" />
      </div>
      <div v-else class="row">
        <div v-for="(device, key) in devices" class="col-sm-6 pb-2" :class="(key % 2 === 0) ? 'pr-1' : 'pl-1'">
          <div :class="{ working: device.working }" class="card device-status h-100">
            <div class="card-body p-1 pl-3">
              <h4 class="ml-2">{{ device.name }}</h4>
              <p>{{ device.lastdatum | relativeFormat }}</p>
              <a :href="device.linkToAdmin" class="float-right">All Data</a>
            </div>
          </div>
        </div>
      </div>
      <div class="device-legend">
        <p class="mb-0"><span class="working">&#x25CF;</span> Device has received data in last 24 Hours</p>
        <p class="mb-0"><span class="failing">&#x25CF;</span> No data has been received in over 24 Hours</p>
      </div>
    </div>
    <div v-else class="center">
      <p>Device Information will display after a page refresh</p>
    </div>
  </div>
</template>
<script>

  import moment from 'moment';
  import axios from 'axios';

  export default {
    filters: {
      relativeFormat: function (dt) {
        return moment(dt).calendar();
      }
    },
    props: {
      config: {
        type: Object,
        default: () => {
          return { endpoint: null }
        }
      }
    },
    data: function () {
      return {
        loading: true,
        devices: []
      }
    },
    mounted: function () {
      if (this.config.endpoint) {
        axios
          .get(
            this.config.endpoint,
            {
              headers: {'X-Requested-With': 'XMLHttpRequest'},
            }
          )
          .then(res => {
            this.loading = false;
            this.devices = res.data;
          });
      }
    },
  };
</script>
<style scoped>
  .center p {
    font-weight: bold;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
